import styled from 'styled-components'
import { Text, TextButton } from '@amzn/storm-ui'

export const StyledBulkEditContainer = styled.div`
  display: flex;
  margin: ${({ theme }) => theme.spacing.micro};
  height: 31px;
  justify-content: space-between;
`

export const BulkEditHeaderText = styled(Text)`
  padding: ${({ theme }) => theme.spacing.micro};
`

export const BulkEditHeaderDivider = styled(Text)`
  padding: ${({ theme }) => theme.spacing.micro};
`

export const ChildrenContainer = styled.div`
  margin: ${({ theme }) => theme.spacing.micro};
`

export const ClearButton = styled(TextButton)`
  color: ${({ theme }) => theme.palette.black};
  padding: 0 ${({ theme }) => theme.spacing.base};
`

export const AdvertisersModalText = styled(Text)`
  width: 450px;
`
